import axios from "axios";
import { API_BASEURL } from "../api";

export const fetchCategoryApi = async () => {
  const { data } = await axios.get(`${API_BASEURL}/product-category`);
  return data;
};
